module.exports = __webpack_public_path__ + "static/media/banner_1.e5254b28.png";